import { useEffect, useState } from 'react'
import { ContentSteps } from 'src/lib/useStepFlow'

import Ticket from 'src/icons/ticket.webp'
import QuestionMark from 'src/icons/question-mark.webp'
import CurrencyRo from 'src/icons/currency-ro.webp'
import CurrencyEn from 'src/icons/currency-en.webp'
import cn from 'classnames'
import { useLocalizedText } from 'src/shared/utils/use-localized-text/useLocalizedText'
import { texts } from './text-third-step'
import { TLang } from 'src/constants/langs'
import cls from './styles.module.scss'

type TProps = {
    onNext: (step: ContentSteps) => void
    step: ContentSteps
    lang: TLang
}

export const ThirdStep = ({ onNext, step, lang }: TProps) => {
    const { header } = useLocalizedText(lang, texts)
    const [stopPulse, setStopPulse] = useState<{ [key: number]: boolean }>({
        0: false,
        1: false,
        2: false,
    })

    const [isLocked, setIsLocked] = useState(false)

    const imageByLang = lang === 'ro' ? lang : 'en'

    const handleCardClick = (index: number) => {
        if (isLocked || stopPulse[index]) return

        setStopPulse((prev) => ({
            ...prev,
            [index]: true,
        }))
    }

    useEffect(() => {
        const trueCount = Object.values(stopPulse).filter((v) => v).length

        if (trueCount === 2) {
            setIsLocked(true)
            const timeout = setTimeout(() => {
                onNext(step)
            }, 1000)
            return () => clearTimeout(timeout)
        }
    }, [stopPulse, onNext, step])

    return (
        <div className={cls.root}>
            <div className={cls.text_wrapper}>{header}</div>
            <div className={cls.tickets_wrapper}>
                {Array.from({ length: 3 }).map((_, index) => (
                    <div
                        key={index}
                        onClick={
                            !stopPulse[index]
                                ? () => handleCardClick(index)
                                : undefined
                        }
                        className={cn(cls.ticket_wrapper, cls.ticket_pulse, {
                            [cls.stop_ticket_pulse]: stopPulse[index],
                        })}
                    >
                        <img
                            src={Ticket}
                            alt="Ticket"
                            className={cn(cls.ticket)}
                        />

                        <img
                            src={imageByLang === 'ro' ? CurrencyRo : CurrencyEn}
                            alt={`Currency__${imageByLang}`}
                            className={cn(
                                cls.currency,
                                cls[`currency__${imageByLang}`],
                                stopPulse[index] ? cls.visible : cls.hidden
                            )}
                        />

                        <img
                            src={QuestionMark}
                            alt="QuestionMark"
                            className={cn(
                                cls.question_mark,
                                !stopPulse[index] ? cls.visible : cls.hidden
                            )}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}
